module.exports = __webpack_public_path__ + "static/img/logo-nife-lg-notext.bded1751.png";